import { isAnyNumericalAxis } from '../../types/guards.js';
import type { XYChartAxisInternal } from '../../types/xy-chart-internals.js';

export const isValidAnnotationsAxis = (
  xAxisId: string,
  axesConfig: XYChartAxisInternal[],
) => {
  const axis = axesConfig.find((axis) => axis.id === xAxisId);
  return !!axis && axis.coordinate === 'x' && isAnyNumericalAxis(axis);
};
